import React from 'react';
import './MusicMarketingSecondSection.scss';
import { Box, Typography } from '@mui/material';
import thumbnailImage from '../../../assets/Images/Marketing/Thumbnail 1.jpg';
import thumbnailImage2 from '../../../assets/Images/Marketing/Thumbnail 2.jpg';
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

function MusicMarketingSecondSection() {
    // Function to handle thumbnail clicks
    const handleThumbnailClick = (youtubeLink) => {
        window.open(youtubeLink, '_blank'); // Open the YouTube link in a new tab
    };

    const navigate = useNavigate()
    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/support/legal-forms/3');
        window.scrollTo(0, 0);
    };

    return (
        <Box className="music-marketing-second-section">
            <Box className="videos">
                {/* First Thumbnail with YouTube link */}
                <Box
                    className="video-wrapper top-video"
                    onClick={() => handleThumbnailClick('https://youtu.be/UupQVtfqTSI?si=H44aZP3GyK5W3GZu')}
                    style={{ cursor: 'pointer' }} // Add pointer cursor to indicate it's clickable
                >
                    <img src={thumbnailImage} alt="Thumbnail 1" className="thumbnail-image" />
                </Box>

                {/* Second Thumbnail with YouTube link */}
                <Box
                    className="video-wrapper bottom-video"
                    onClick={() => handleThumbnailClick('https://youtu.be/QGawxWLQrkQ?si=jSpzy240Zwbx5C9H')}
                    style={{ cursor: 'pointer' }} // Add pointer cursor to indicate it's clickable
                >
                    <img src={thumbnailImage2} alt="Thumbnail 2" className="thumbnail-image" />
                </Box>
            </Box>

            <Box className="content">
                <Typography variant="h3">Creative Content Development</Typography>
                <Typography className="description">
                    We thrive on crafting exceptional content with our partners. Our in-house team collaborates with artists to produce high-quality content that stands out.
                </Typography>
                <Typography className="description">
                    From music videos and visualizers to lyric videos and short-form content, FM Digital Official’s Label Services team is dedicated to helping you unlock your full creative potential.
                </Typography>
                <UnifiedButton onClick={handleplaylistformClick} variant="contained" className="cta-button" textContent={"Simply fill out this form."} />
            </Box>
        </Box>
    );
}

export default MusicMarketingSecondSection;
